import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f801120")

_pushScopeId("data-v-1f801120")
const _hoisted_1 = { class: "acu-image" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "経穴の編集", -1)
const _hoisted_3 = { class: "acu-list" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("経穴追加 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_body_parts_image = _resolveComponent("body-parts-image")
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_head_button_frame = _resolveComponent("vue-head-button-frame")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "acu-frame" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_body_parts_image, {
          direction: _ctx.selectedDirection,
          partsId: _ctx.selectedBodyParts,
          acuList: _ctx.acuList,
          onClick: _ctx.onClickImage
        }, null, 8, ["direction", "partsId", "acuList", "onClick"]),
        _createVNode("div", {
          class: ["image-info", _ctx.$mq]
        }, "経穴リストを選択して上の画像をクリックすると、経穴の位置を設定できます", 2)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_list_title, {
          class: "parts-title",
          titles: _ctx.acuListTitles
        }, null, 8, ["titles"]),
        _createVNode(_component_vue_y_scroll_area, null, {
          default: _withId(() => [
            _createVNode(_TransitionGroup, null, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.acuPartsRows, (row, i) => {
                  return (_openBlock(), _createBlock(_component_list_row, {
                    key: row.id,
                    rowId: row.id,
                    columns: row.columns,
                    onClick: ($event: any) => (_ctx.onClick(i, $event)),
                    onName: ($event: any) => (_ctx.onInputName(i, $event)),
                    onRow: ($event: any) => (_ctx.selectRow(row.id)),
                    selected: row.id === _ctx.selectedRowId
                  }, null, 8, ["rowId", "columns", "onClick", "onName", "onRow", "selected"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_vue_head_button_frame, { class: "parts-button-frame" }, {
              default: _withId(() => [
                _createVNode(_component_normal_button, {
                  class: "vue-head-button-frame-button",
                  state: "normal",
                  disabled: !_ctx.dataWrite,
                  onClick: _ctx.addAcuItem
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})